import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Wind } from "lucide-react";

interface IVentilationType {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function VentilationType(props: IVentilationType) {
    const { value, onChange, loading } = { ...props };
    const [ventilationType, setVentilationType] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setVentilationType(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setVentilationType(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Ventilation Type
            </Typography>

            <Select
                placeholder="Select ventilation type"
                value={ventilationType}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Wind size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Box Vent">Box Vent</Option>
                <Option value="Ridge Vent">Ridge Vent</Option>
            </Select>
        </Box>
    );
}
